import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { Reveal, SectionHeading } from "../components/Common";
import { IMAGES, HOUSE_BRANDS } from "../mock/mock";

const brandImages = [IMAGES.oudChips, IMAGES.perfumeGold, IMAGES.forest2, IMAGES.whiteSmoke];

const House = () => {
  return (
    <div className="bg-noir">
      <Seo
        title="The House of Meilleur — One House, Four Oud Brands"
        description="The House of Meilleur: Meilleur Oudh & Aromas, The Scent Lab, Meilleur Land & Agro Capital Ventures and Ikara Scents — rooted in 103 acres of agarwood in North East India."
        path="/house"
        keywords="House of Meilleur, oud brands, The Scent Lab, Ikara Scents, agarwood investment, Meilleur Land Agro"
      />
      <PageHero eyebrow="Brand Architecture" title="The House of" accent="Meilleur" image={IMAGES.perfumeGold2} crumbs={["The House"]} />

      <section className="py-28">
        <div className="max-w-[1360px] mx-auto px-6 md:px-10">
          <div className="max-w-3xl mx-auto text-center">
            <Reveal><SectionHeading eyebrow="One House, Four Brands" title="Rooted in the same" accent="forest" align="center" /></Reveal>
            <Reveal delay={120}>
              <p className="mt-8 text-[var(--ivory-muted)] text-lg leading-relaxed font-body font-light">
                Meilleur Plantations is the root of the house — the plantation, inoculation and sourcing engine. From
                that root, four distinct brands have grown, each serving a different part of the agarwood and fragrance
                value chain, from raw material to retail counter to investment portfolio.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="pb-16">
        <div className="max-w-[1360px] mx-auto px-6 md:px-10 space-y-8">
          {HOUSE_BRANDS.map((b, i) => (
            <Reveal key={b.num} delay={i * 80}>
              <div className={`grid lg:grid-cols-12 gap-10 items-center ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}>
                <div className="lg:col-span-6 [direction:ltr]">
                  <div className="img-zoom relative">
                    <img src={brandImages[i]} alt={b.name} className="w-full h-[380px] object-cover" />
                    <div className="absolute inset-0 border border-[var(--line)]" />
                    <div className="absolute top-6 left-6 font-serif-display text-7xl text-white drop-shadow-lg opacity-95">{b.num}</div>
                  </div>
                </div>
                <div className="lg:col-span-6 [direction:ltr]">
                  <div className="eyebrow mb-4">Brand {b.num}</div>
                  <h3 className="font-serif-display text-4xl md:text-5xl mb-5">{b.name}</h3>
                  <p className="text-[var(--ivory-muted)] text-lg leading-relaxed font-body font-light max-w-lg">{b.desc}</p>
                  {i === 0 && (
                    <Link to="/oud-chips" className="btn-ghost mt-8">View Collections <ArrowRight size={15} /></Link>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-[1360px] mx-auto px-6 md:px-10">
          <Reveal>
            <div className="p-12 md:p-16 text-center relative overflow-hidden rounded bg-green on-green">
              <div className="relative">
                <p className="font-serif-display text-2xl md:text-3xl italic leading-[1.4] max-w-3xl mx-auto text-white">
                  "Every brand traces back to the same forest — the same <span className="text-[#e7dcb8]">103 acres</span> of
                  Aquilaria in Assam, Tripura and Nagaland — expressed differently for the farmer, the customer, the
                  investor, and the space designer."
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default House;
